/** Pre-login marketing site document paths — main nitromule.com only (not portals). */

export const MARKETING_DOCUMENT_SEGMENTS = new Set([
  'portals',
  'shipping',
  'solutions',
  'integrations',
  'pricing',
  'download',
  'login',
  'signup'
]);

export function isMarketingDocumentPath(pathname) {
  const norm = String(pathname || '').split('?')[0].replace(/\/$/, '') || '/';
  if (norm === '/') return true;
  const parts = norm.replace(/^\//, '').split('/').filter(Boolean);
  if (parts.length !== 1) return false;
  return MARKETING_DOCUMENT_SEGMENTS.has(parts[0].toLowerCase());
}
